import { render, staticRenderFns } from "./CharacterBuilderAbilityScores.vue?vue&type=template&id=62657456&lang=pug&"
import script from "./CharacterBuilderAbilityScores.vue?vue&type=script&lang=ts&"
export * from "./CharacterBuilderAbilityScores.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
